
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

interface ContactFormPlanningServiceProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ContactFormPlanningService = ({ checked, onChange }: ContactFormPlanningServiceProps) => {
  const { t } = useLanguage();
  
  return (
    <label className="flex items-center space-x-2 cursor-pointer">
      <input
        type="checkbox"
        name="planningService"
        checked={checked}
        onChange={onChange}
        className="form-checkbox h-4 w-4 text-primary dark:border-gray-600"
      />
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {t('contact_design_services')}
      </span>
    </label>
  );
};

export default ContactFormPlanningService;
